import { useEffect } from 'react';
import { useFormikContext } from 'formik';

const ErrorFocus = () => {
  const { isSubmitting, isValidating, errors } = useFormikContext();
  useEffect(() => {
    const keys = Object.keys(errors);
    if (keys.length > 0 && isSubmitting && !isValidating) {
      document.getElementById(`error-${keys[0]}`)?.parentNode?.scrollIntoView({
        behavior: 'smooth',
      });
    }
  }, [isSubmitting, isValidating, errors]);

  return null;
};

export default ErrorFocus;
